import { StateCreator } from "zustand";

import type { SearchStore } from "@/stores/search";

// Search-page UI that more than one part of the tree needs to drive: the page
// breaks open the review modal and the filters dialog from deep in the list.
export interface UiSliceState {
  isReviewOpen: boolean;
  // Bumped to ask the filters dialog to open; it owns its own open state.
  filtersDialogRequestId: number;
}

export interface UiSliceActions {
  setIsReviewOpen: (isReviewOpen: boolean) => void;
  requestFiltersDialog: () => void;
}

export type UiSlice = UiSliceState & UiSliceActions;

export const createUiSlice: StateCreator<SearchStore, [], [], UiSlice> = (
  set,
  get,
) => ({
  isReviewOpen: false,
  filtersDialogRequestId: 0,

  setIsReviewOpen: (isReviewOpen) => {
    set({ isReviewOpen });
  },

  requestFiltersDialog: () => {
    set({ filtersDialogRequestId: get().filtersDialogRequestId + 1 });
  },
});
